import React, {useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Form, Button } from "react-bootstrap";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { CreateUser } from "src/Thunk/adminThunks";
import { clearMsg } from "src/Actions/Admin/adminActions";
const MySwal = withReactContent(Swal);

const AddNewUser = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const {msg,error} = useSelector((state) => state.admin)
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm();

  const handleSave = (data) => {
    dispatch(CreateUser(data))
  };

  useEffect(() => {
    if (msg) {
      MySwal.fire({
        icon: "success",
        title: msg,
      });
      setTimeout(() => {
       dispatch(clearMsg())
      },1200)
      reset();
      navigate('/UserList')
    }
    if (error) {
      MySwal.fire({
        icon: "error",
        title: error,
      });
    }
  }, [msg, error]);
  return (
    <>
      <div className="main-content">
        <div className="page-content">
          <div className="container-fluid">
            <div className="row mb-3">
              <div className="col-12">
                <div className="page-title-box d-flex align-items-center justify-content-between">
                  <h4 className="mb-0 text-info">ADD NEW USER</h4>
                  <div className="page-title-right">
                    <ol className="breadcrumb m-0">
                      <li className="breadcrumb-item">
                        <Link to="/">Home</Link>
                      </li>
                      <li className="breadcrumb-item active text-info">
                        Add New User
                      </li>
                    </ol>
                  </div>
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-xl-12">
                <div className="card custom-shadow rounded-lg border my-2">
                  <div className="card-body">
                    <Form onSubmit={handleSubmit(handleSave)}>
                      <div className="row">
                        <Form.Group className="col-lg-4 mb-3">
                          <Form.Label>Sign Up as a*</Form.Label>
                          <select
                            className="form-select"
                            {...register("userType", {
                              required: "user type is required",
                            })}
                          >
                            <option>select user type</option>
                            <option>Patient</option>
                            <option>Doctor</option>
                          </select>
                          {errors.userType && (
                            <p className="text-danger">
                              userType is required
                            </p>
                          )}
                        </Form.Group>
                        <Form.Group className="col-lg-4 mb-3">
                          <Form.Label>Name</Form.Label>
                          <Form.Control
                            type="text"
                            placeholder="Enter Name"
                            {...register("Name", {
                              required: "Name is required",
                            })}
                          />
                          {errors.Name && (
                            <p className="text-danger">{errors.Name.message}</p>
                          )}
                        </Form.Group>
                        <Form.Group className="col-lg-4 mb-3">
                          <Form.Label>Gender</Form.Label>
                          <select
                            {...register("Gender", {
                              required: 'Gender is required',
                            })}
                            className="form-select"
                          >
                            <option>select gender</option>
                            <option>Male</option>
                            <option>Female</option>
                          </select>
                          {errors.Gender && (
                            <p className="text-danger">{errors.Gender.message}</p>
                          )}
                        </Form.Group>
                        <Form.Group className="col-lg-4 mb-3" controlId="email">
                          <Form.Label>Email</Form.Label>
                          <Form.Control
                            type="email"
                            autoComplete="email"
                            placeholder="Enter Email"
                            {...register("email", {
                              required: "Email is required",
                              pattern: {
                                value: /^[a-z0-9._-]+@[a-z]+\.[a-z]{2,3}$/,
                                message: "Invalid email format",
                              },
                            })}
                          />
                          {errors.email && (
                            <p className="text-danger">
                              {errors.email.message}
                            </p>
                          )}
                        </Form.Group>
                        <Form.Group
                          className="col-lg-4 mb-3"
                          controlId="password"
                        >
                          <Form.Label>Password</Form.Label>
                          <Form.Control
                            type="password"
                            autoComplete="off"
                            placeholder="Enter Password"
                            {...register("password", {
                              required: "Password is required",
                              minLength: {
                                value: 8,
                                message:
                                  "Password must be at least 8 characters long",
                              },
                              maxLength: {
                                value: 15,
                                message:
                                  "Password must not exceed 15 characters",
                              },
                            })}
                          />
                          {errors.password && (
                            <p className="text-danger">
                              {errors.password.message}
                            </p>
                          )}
                        </Form.Group>
                        <div className="text-end">
                          <Button
                            variant="info"
                            className="btn btn-primary text-white m-2"
                            type="submit"
                          >
                            ADD
                          </Button>
                        </div>
                      </div>
                    </Form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AddNewUser;
